export default "__VITE_ASSET__149a6766__"